<script setup lang="ts">
import { EventListPageType } from '~/composables/types/strapiEventListPage'

definePageMeta({
  contentGroup: 'category',
})
</script>

<template>
  <event-list-page :page-type="EventListPageType.CATEGORY"></event-list-page>
</template>
